module.exports = __webpack_public_path__ + "img/Icon-underlined.e04fb3e3.svg";